import React, {useState, useCallback, useEffect, useContext} from 'react'
import { useHistory, useLocation } from "react-router-dom";
import { AuthContext } from "../../components/Auth/AuthDataProvider";
import apiUtil from "../../api/apiUtil";
import Api from "../../api/api";
import StickyPageHeader from '../../components/PageHeader/StickyPageHeader';
import Card from '../../components/Card/Card.jsx';
import CustomCropper from '../../components/Cropper/CustomCropper.jsx';
import BreadCrumb from "../../components/Navs/Breadcrumb";
import { 
    Box,
    Grid,
    Container,
    Divider,
    IconButton,
    CircularProgress,
    Button,
    Dialog,
  } from '@material-ui/core';

import CloseIcon from '@material-ui/icons/Close';
import CustomLabel from '../../components/CustomFields/CustomLabel';
import CustomInput from '../../components/CustomFields/CustomInput';
import CustomButton from '../../components/CustomFields/CustomButton';
import CustomDialog from '../../components/Dialog/CustomDialog.jsx';


    const Password = () => {
    // let grantedMenu = new RoleAccessService();
    // let currentRole = window.localStorage.getItem('current_role');

    const history = useHistory();
    const location = useLocation();
    const { accessToken } = useContext(AuthContext)
    const pathName = (location && location.state && location.state.pathname && location.state.pathname.length > 0) ? location.state.pathname : "/";
    const [value, setValue] = useState(0);
    const [ isLoading, setIsLoading ] = useState(false);
    const [ isLoadingRead, setIsLoadingRead ] = useState(false);

    // general section
    const [personalName, setPersonalName] = useState("")
    const [personalEmail, setPersonalEmail] = useState("")
    const [personalPassword, setPersonalPassword] = useState("")
    const [newPassword, setNewPassword] = useState("")
    const [retryPassword, setRetryPassword] = useState("")
    const [alertDialog, setAlertDialog] = useState(false)
    const [newPasswordValidated, setNewPasswordValidated] = useState(false)
    const [retryPasswordValidated, setRetryPasswordValidated] = useState(false)
    const [personalProfileImageURL, setPersonalProfileImageURL] = useState("")
    const [personalProfileOldData, setPersonalProfileOldData] = useState("")
    
    const settingsAccountProfile = () => {
        return <Box style={{padding: '20px'}}><Grid container p={1} >
                <Box clone>
                    <Grid item xs={12}>
                        <CustomInput
                            label={'Current Password'}
                            // placeholder={'City'}
                            className="input-label--horizontal"
                            value={personalPassword}
                            type="password"
                            // error={lastNameValidated}
                            // required={true}
                            // autoFocus={true}
                            onChange={e => {
                                setPersonalPassword(e.target.value) 
                            }}
                        />
                    </Grid>
                </Box>
                <Box clone>
                    <Grid item xs={12}>
                        <CustomInput
                            label={'New Password'}
                            // placeholder={'City'}
                            className="input-label--horizontal"
                            value={newPassword}
                            error={newPasswordValidated}
                            type="password"
                            // required={true}
                            // autoFocus={true}
                            onChange={e => {
                                setNewPassword(e.target.value)
                                // setLastNameValidated((e.target.value !== '') ? false : true) 
                            }}
                        />
                    </Grid>
                </Box>
                <Box clone>
                    <Grid item xs={12}>
                        <CustomInput
                            label={'Retype New Password'}
                            // placeholder={'City'}
                            className="input-label--horizontal"
                            type="password"
                            value={retryPassword}
                            error={retryPasswordValidated}
                            // required={true}
                            // autoFocus={true}
                            onChange={e => {
                                setRetryPassword(e.target.value)
                                // setLastNameValidated((e.target.value !== '') ? false : true) 
                            }}
                        />
                    </Grid>
                </Box>
                <Box clone>
          <Grid item xs={'auto'}>
            <CustomButton 
              type={'submit'}
              color={'secondary'}
              isLoading={isLoading}
            >
              <Box pl={2} pr={2}>Save Changes</Box>
            </CustomButton>
          </Grid>
        </Box>
            </Grid>
        </Box>;
    } 
    
    const handleClose = () => {
        setAlertDialog(false);
    };

    const popUpDialog = () => {
        return <CustomDialog 
        open={alertDialog}
        title={'Warning !'}
        btnOkText={'OK'}
        onClose={() => {
            handleClose();
        }}
        onOk={() => {
            handleClose();
        }}
      >
        <Box>
            <p>Wrong current password</p></Box>
      </CustomDialog>
    }



    const handleSubmit = async e => {
        e.preventDefault();
        e.stopPropagation();
    
        let currentPassword = window.localStorage.getItem('password');

        if(window.btoa(personalPassword) != currentPassword) {
            setAlertDialog(true);
            return
        }

        if (newPassword === '') {
          setNewPasswordValidated(true)
          apiUtil.toast('New password required', 'error');
          return
        }

        if (retryPassword === '') {
            setRetryPasswordValidated(true)
            apiUtil.toast('retry password required', 'error');
            return
          }

        if (newPassword !== retryPassword) {
          setNewPasswordValidated(true)
          setRetryPasswordValidated(true)
          apiUtil.toast('two password doesn\'t match', 'error');
          return
        }

          let row = {
            "password": newPassword,
          }
          if(Object.keys(row).length > 0) {
            Object.assign(row, {appName:"AUTH"}); 
        }
          Api.updatePassword('profile/admins', row, accessToken)
          .then((result) => {
              apiUtil.parseResult(result, (data) => {
                  setIsLoading(false);
                  window.localStorage.setItem('password', window.btoa(newPassword));
                  history.push("/dashboard");
                  apiUtil.toast('Successfully Updated Password', 'check_circle');
                 
              }, (error, type) => {
                  setIsLoading(false);
                 
              });
          }).catch(
            //   error => console.log(error)
          )
       
      }
    return (
    <Box className="settings--form" >
        <form noValidate autoComplete="off" onSubmit={handleSubmit}>
            <StickyPageHeader>
                <Container>
            <BreadCrumb />
                <h1 className="page-title">Change Password</h1>
            </Container>
            </StickyPageHeader>
            <Container maxWidth="lg">
                <Grid container>

                    {/* <Grid item xs={3}>
                        <Box clone marginTop={3}>
                        <Tabs
                            orientation="vertical"
                            variant="scrollable"
                            value={value}
                            onChange={handleChange}
                            aria-label="Settinsg Menus"
                        >
                            <Tab label="Account Profile" {...a11yProps(0)} />
                        </Tabs>
                        </Box>
                    </Grid> */}

                    {/* <Grid item xs={9}> */}
                    <Grid item xs={12} style={{paddingTop: '20px'}}>
                        <Card>
                            {
                                isLoadingRead
                                ?
                                <Box display={'flex'} alignItems={'center'} justifyContent={'center'} height={'55vh'}>
                                    <CircularProgress size={35} />
                                </Box>
                                : 
                                <>
                                {settingsAccountProfile()}
                                {popUpDialog()}
                                
                                </>
                            }
                        </Card>
                    </Grid>
                    
                </Grid>

            </Container>
        </form>
    </Box>
    )
}

export default Password;
